<div class="flex-wrap flex-wrap--flex-start margin-bottom-x2">
  <div class="flex-wrap__col flex-wrap__col--40">
    <div class="contract__edit hidden-btn-edit">
      <small class="wannabe-h1">Abonnement</small>
      <h2 *ngIf="serviceaftale?.serviceAbonnement.isTilkaldsabonnement">Ingen abonnement</h2>
      <h2 *ngIf="!serviceaftale?.serviceAbonnement.isTilkaldsabonnement">
        {{ serviceaftale?.serviceAbonnement?.description }}
        <i class="margin--left-xs tiny-text" *ngFor="let tilvalg of serviceaftale.tilvalg">{{ tilvalg.name }}</i>
        <i class="margin--left-xs tiny-text" *ngIf="!serviceaftale.tilvalg || serviceaftale.tilvalg.length == 0">
          Ingen tilvalg til denne aftale
        </i>
      </h2>

      <button
        *ngIf="!isServiceaftaleTerminatedOrPendingTermination()"
        type="button"
        class="btn-icon btn-blue-edit"
        matTooltip="Rediger abonnement"
        [disabled]="!canEditAbonnement"
        (click)="editAbonnement()"
      >
        <mat-icon svgIcon="edit"></mat-icon>
      </button>

      <div class="tiny-text" *ngIf="isServiceaftalePendingTermination() && canServiceaftaleBeReactivated()">
        Fortryd først opsigelse af aftalen, hvis du vil ændre på abonnement og/eller tilvalg
      </div>
    </div>

    <div class="card">
      <form [formGroup]="abonnementForm" [attr.autocomplete]="'off'">
        <div class="data" *ngIf="isServiceaftaleTerminatedOrPendingTermination() || serviceaftale.endDate != null">
          <div class="data__subrow">
            <div class="contract-state contract-state--inactive">
              <mat-icon svgIcon="alert-solid"></mat-icon>
              <span *ngIf="isServiceaftaleTerminatedOrPendingTermination() || serviceaftale.endDate != null">
                Aftalen opsagt pr. {{ serviceaftale.endDate | date }}
              </span>
            </div>
          </div>
          <div class="btn-in-the-corner">
            <button
              *ngIf="canServiceaftaleBeReactivated()"
              (click)="reactivateServiceAgreement.emit()"
              [disabled]="!canReactivate"
              class="btn-icon blue"
              matTooltip="Fortryd opsigelse"
            >
              <mat-icon class="no-margin" svgIcon="undo"></mat-icon>
            </button>
          </div>
        </div>

        <div>
          <app-garantiaftale-tag [serviceaftale]="serviceaftale"></app-garantiaftale-tag>
          <mat-chip-option class="orange-bg" *ngIf="isNaerVarme">
            <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
            Nærvarme
          </mat-chip-option>
          <mat-chip-option class="orange-bg" *ngIf="isLeasing">
            <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
            Leasing
          </mat-chip-option>
          <mat-chip-option
            *ngIf="upcomingChanges?.hasChanges"
            class="orange-border orange trans-bg cursor-pointer"
            (click)="showUpcomingChanges()"
            [disableRipple]="true"
          >
            <mat-icon svgIcon="obs-solid" class="orange margin--right-xs"></mat-icon>
            Ændringer på vej
          </mat-chip-option>
          <mat-chip-option class="orange-bg" *ngIf="isGasfyrTryghed">
            <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
            Gasfyr Tryghed
          </mat-chip-option>
        </div>

        <div class="data">
          <div class="data__lbl" *ngIf="serviceaftale.serviceaftaleTags.length > 0">Tags</div>
          <div class="data__val no-margin-right">
            <app-edit-tags [serviceaftale]="serviceaftale"></app-edit-tags>
          </div>
        </div>
        <div class="data">
          <ng-container *ngIf="!canEditStartDato()">
            <div class="data__lbl">Startdato</div>
            <div class="data__val">{{ serviceaftale.startDate | date : 'shortDate' }}</div>
          </ng-container>
          <ng-container *ngIf="canEditStartDato()">
            <div class="data__subrow">
              <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
                <span></span>
                <app-info
                  inline="true"
                  tooltip="Den dato hvorfra en serviceaftale er gældende. En serviceaftale startes normalt - men ikke nødvendigvis - op fra d.d."
                ></app-info>
              </div>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Startdato</mat-label>
                <mat-datepicker-toggle matPrefix [for]="startDatepicker"></mat-datepicker-toggle>
                <input
                  #startDateInput
                  matInput
                  [matDatepicker]="startDatepicker"
                  formControlName="startDate"
                  (dateChange)="onDateChange()"
                  (keydown.enter)="$event.target.blur(); (false)"
                />

                <mat-datepicker #startDatepicker></mat-datepicker>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div class="data">
          <div
            class="data__subrow"
            *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement && !isServiceaftaleTerminated()"
            [class.data--inactive]="isServiceaftaleTerminatedOrPendingTermination()"
          >
            <ng-container *ngIf="!canEditNaesteEftersyn">
              <div class="data__lbl">Næste eftersyn</div>
              <div class="data__val">
                <span>{{ serviceaftale.naesteEftersynDate | date : 'shortDate' }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="canEditNaesteEftersyn">
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Næste eftersyn</mat-label>
                <input
                  #naesteEftersynInput
                  matInput
                  [matDatepicker]="naesteEftersynDatePicker"
                  formControlName="naesteEftersynDate"
                  (dateChange)="onDateChange()"
                  (keydown.enter)="$event.target.blur(); (false)"
                />
                <mat-datepicker-toggle matPrefix [for]="naesteEftersynDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #naesteEftersynDatePicker></mat-datepicker>
              </mat-form-field>
            </ng-container>
          </div>
          <div class="data__subrow">
            <div class="data__lbl">
              Serviceintervaller
              <ng-container *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement">
                ·
                <span class="blue-dark">Hver {{ serviceaftale.serviceAbonnement.eftersynInterval }}. mdr</span>
              </ng-container>
            </div>
            <div class="data__val">
              <div *ngIf="serviceaftale.serviceintervaller" class="interval-dialog-btn">
                <div *ngIf="serviceaftale.currentServiceinterval">
                  {{ $safeNavigationMigration(serviceaftale.currentServiceinterval?.startDate) | date : 'shortDate' }} -
                  {{ $safeNavigationMigration(serviceaftale.currentServiceinterval?.endDate) | date : 'shortDate' }}
                </div>
                <button
                  type="button"
                  class="btn-icon"
                  (click)="showServiceintervaller()"
                  matTooltip="Vis alle serviceintervaller"
                  *ngIf="serviceaftale.serviceintervaller.length > 0"
                >
                  <mat-icon class="btn-icon blue">more_horiz</mat-icon>
                </button>
              </div>
            </div>
            <app-eftersyn-status
              [eftersynState]="$safeNavigationMigration(serviceaftale.currentServiceinterval?.eftersynState?.eftersynState)"
              [serviceordreNo]="$safeNavigationMigration(serviceaftale.currentServiceinterval?.eftersynState.eftersyn?.serviceordreNo)"
            ></app-eftersyn-status>
          </div>
        </div>
        <div class="data" *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement">
          <div class="data__subrow">
            <div class="data__val">
              <ng-container *ngIf="!canFastForward">
                <div class="data__lbl">Næste opkrævningsdato</div>
                <div class="data__val">
                  {{ serviceaftale.opkraevningDate | date : 'dd.MM.yyyy' }}
                </div>
              </ng-container>
              <ng-container *ngIf="canFastForward">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>Opkrævningsdato</mat-label>
                  <input
                    #opkraevningInput
                    matInput
                    [matDatepicker]="opkraevningDatePicker"
                    formControlName="opkraevningDate"
                    (dateChange)="onDateChange()"
                    (keydown.enter)="$event.target.blur(); (false)"
                  />
                  <mat-datepicker-toggle matPrefix [for]="opkraevningDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #opkraevningDatePicker></mat-datepicker>
                  <button
                    [disabled]="!isAdmin && !isSuperUser"
                    (click)="fastForwardOpkraevningsdate()"
                    class="btn-icon inline-flex blue"
                    aria-label="Spol opkrævningsdato frem"
                    matTooltip="Spol opkrævningsdato frem"
                    matSuffix
                  >
                    <mat-icon svgIcon="forward"></mat-icon>
                  </button>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
          <div class="data__subrow">
            <div class="data__lbl">Opkrævningsinterval</div>
            <div class="data__val">
              <div class="icon-with-text">
                <span
                  [class.cursor-help]="
                    serviceaftale.opkraevningsinterval != null &&
                    serviceaftale.opkraevningsinterval != serviceaftale?.serviceAbonnement?.opkraevningInterval
                  "
                  [matTooltipDisabled]="
                    serviceaftale?.opkraevningsinterval == null ||
                    serviceaftale?.opkraevningsinterval == serviceaftale?.serviceAbonnement?.opkraevningInterval
                  "
                  [matTooltip]="
                    'Opkrævningsintervallet *' +
                    $safeNavigationMigration(serviceaftale?.opkraevningsinterval) +
                    '* afviger fra det normale på ' +
                    serviceaftale.serviceAbonnement.opkraevningInterval +
                    ' måneder via abonnementet'
                  "
                >
                  Hver
                  <span *ngIf="!serviceaftale.opkraevningsinterval">
                    {{ serviceaftale.serviceAbonnement.opkraevningInterval }}
                  </span>
                  <span *ngIf="serviceaftale.opkraevningsinterval">{{ serviceaftale.opkraevningsinterval }}.</span>
                  mdr.&nbsp;
                </span>
                <button
                  type="button"
                  class="btn-icon blue"
                  matTooltip="Rediger opkrævningsinterval"
                  *ngIf="!isServiceaftaleTerminatedOrPendingTermination()"
                  (click)="editOpkraevningsInterval()"
                >
                  <mat-icon class="blue" svgIcon="edit"></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div class="data__subrow">
            <div class="data__lbl">Opkrævning status</div>
            <div class="data__val">
              <app-opkraevnings-status
                [opkraevningState]="$safeNavigationMigration(serviceaftale.currentServiceinterval?.opkraevningState)"
              ></app-opkraevnings-status>
            </div>
          </div>
          <div class="data__subrow">
            <div class="data__lbl">Partnerafregning status</div>
            <div class="data__val">
              <ng-container [ngSwitch]="$safeNavigationMigration(serviceaftale.currentServiceinterval?.partnerOpkraevningState)">
                <div class="flex-wrap flex-wrap--flex-start flex-wrap--align-center tiny-text">
                  <ng-container *ngSwitchCase="opkraevningStateEnum.FullyOpkraevet">
                    <mat-icon svgIcon="thumb-up" class="green"></mat-icon>
                    <i class="no-line-height">Fuldt afregnet</i>
                  </ng-container>
                  <ng-container *ngSwitchCase="opkraevningStateEnum.NotOpkraevet">
                    <mat-icon svgIcon="thumb-down" class="red"></mat-icon>
                    <i class="no-line-height">IKKE afregnet</i>
                  </ng-container>
                  <ng-container *ngSwitchCase="opkraevningStateEnum.PartOpkraevet">
                    <mat-icon svgIcon="point" class="orange"></mat-icon>
                    <i class="no-line-height">Delvist afregnet</i>
                  </ng-container>
                  <ng-container *ngSwitchDefault></ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="data">
          <div class="data__subrow">
            <div class="data__lbl">Partner</div>
            <div class="data__val">
              <div class="flex flex-wrap--align-center">
                <div
                  class="orange cursor-help flex margin--right-xs"
                  *ngIf="upcomingChanges?.hasPartnerChanges"
                  [matTooltip]="
                    'Partner skifter til ' +
                    $safeNavigationMigration(upcomingChanges?.upcomingPartner?.name) +
                    ' d. ' +
                    ($safeNavigationMigration(upcomingChanges?.partnerValidFrom) | date : 'dd.MM.yyyy')
                  "
                >
                  <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
                </div>
                <button type="button" (click)="openPartnerInfo()" class="btn-icon blue">
                  {{ serviceaftale.partner.name }}
                </button>
                <button
                  type="button"
                  [disabled]="!canWrite"
                  matTooltip="Rediger partner"
                  (click)="editPartner()"
                  class="btn-icon margin--left-xs blue"
                >
                  <mat-icon svgIcon="edit"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="data__subrow">
            <div class="data" *ngIf="!henviserEditMode || !canWrite">
              <div class="data__lbl">Henviser</div>
              <div class="data__val">
                <div class="flex flex-wrap--align-center">
                  <span *ngIf="serviceaftale.henviser?.name">{{ serviceaftale.henviser?.name }}</span>
                  <span *ngIf="!serviceaftale.henviser?.name">Ingen angivet</span>
                  <button
                    type="button"
                    [disabled]="!canWrite"
                    (click)="editHenviser()"
                    class="btn-icon blue margin--left-xs"
                    matTooltip="Rediger henviser"
                  >
                    <mat-icon svgIcon="edit"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="data" *ngIf="henviserEditMode && canWrite">
              <div class="data__lbl"></div>
              <div class="data__val">
                <app-henviser-input [henvisere]="henvisere" [form]="henviserForm"></app-henviser-input>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form [formGroup]="notesForm" [attr.autocomplete]="'off'">
        <div class="data" *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement">
          <div class="data__lbl">
            <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
              <span>Beskrivelse til næste eftersyn</span>
              <app-info
                tooltip="Beskrivelse til næste eftersyn.	En note der automatisk sendes med til næste (førstkommende) eftersyn."
              ></app-info>
            </div>
          </div>
          <div class="data__val data__val--full">
            <mat-form-field appearance="outline" class="mdc-textarea-fix">
              <textarea id="serviceOrderNote" (blur)="updateNotes()" formControlName="serviceOrderNote" rows="5" matInput></textarea>
              <mat-hint align="end">
                <app-character-count [control]="serviceOrderNote" maxlength="500"></app-character-count>
              </mat-hint>
              <mat-error *ngIf="serviceOrderNote.hasError('maxlength')">
                Beskrivelse til næste eftersyn må højest være 500 karakterer lang
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <form [formGroup]="abonnementForm" [attr.autocomplete]="'off'">
      <div class="card card--no-padding">
        <div *ngIf="g4Error" class="contract-state contract-state--inactive card__padded-content">
          <mat-icon svgIcon="alert-solid"></mat-icon>
          Kunne ikke hente priser i G4.
        </div>
        <table class="mat-mdc-table margin-bottom contract__prices">
          <thead>
            <tr class="mat-mdc-header-row">
              <th class="mat-mdc-header-cell">Priser</th>
              <th class="mat-mdc-header-cell align-right"><span [class.faded]="pricesWithoutMoms">inkl. moms</span></th>
              <th class="mat-mdc-header-cell align-right" *ngIf="pricesWithoutMoms">ekskl. moms</th>
              <th class="mat-mdc-header-cell align-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="mat-mdc-row" [class.not-current]="rabatEnabled || fixedPriceActive">
              <td class="mat-mdc-cell">
                Basispris (årlig)
                <app-info
                  [tooltip]="
                    'Basispris er den årlige pris for det valgte abonnement alene. Dvs. prisen før kundens tilvalg og evt. beregnede tillæg lægges oveni prisen.'
                  "
                  [inline]="true"
                ></app-info>
              </td>
              <td class="mat-mdc-cell align-right">
                <span [class.faded]="pricesWithoutMoms && !(rabatEnabled || fixedPriceActive)">
                  {{ basePrice ? ($safeNavigationMigration(basePrice?.withMoms) | dkCurrency) : '-' }}
                </span>
              </td>
              <td class="mat-mdc-cell align-right" *ngIf="pricesWithoutMoms">
                {{ basePrice ? ($safeNavigationMigration(basePrice?.withoutMoms) | dkCurrency) : '-' }}
              </td>
              <td class="mat-mdc-cell align-right"></td>
            </tr>
            <tr class="mat-mdc-row" [class.not-current]="rabatEnabled || fixedPriceActive" *ngIf="rabatEnabled || fixedPriceActive">
              <td class="mat-mdc-cell">
                Listepris (årlig)
                <app-info
                  [tooltip]="
                    'Listepris er normalprisen for en serviceaftale som denne. Dvs. det en kunder betaler, når der hverken er aftalt rabat eller fastpris.'
                  "
                  [inline]="true"
                ></app-info>
              </td>
              <td class="mat-mdc-cell align-right">
                <span [class.faded]="pricesWithoutMoms && !(rabatEnabled || fixedPriceActive)">
                  {{ listPrice ? ($safeNavigationMigration(listPrice?.withMoms) | dkCurrency) : '-' }}
                </span>
              </td>
              <td class="mat-mdc-cell align-right" *ngIf="pricesWithoutMoms">
                {{ listPrice ? ($safeNavigationMigration(listPrice?.withoutMoms) | dkCurrency) : '-' }}
              </td>
              <td class="mat-mdc-cell align-right"></td>
            </tr>
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell bold">
                Totalpris (årlig)
                <ng-container *ngIf="fixedPriceActive">(fastpris)</ng-container>
                <ng-container *ngIf="serviceaftale.rabatProcent || serviceaftale.rabatKontantExclMoms">(rabat)</ng-container>
                <app-info
                  [tooltip]="'Totalpris er den årlige pris som kunden skal betale for denne serviceaftale (alt inkl.).'"
                  [inline]="true"
                ></app-info>
              </td>
              <td class="mat-mdc-cell align-right bold relative">
                <span [class.faded]="pricesWithoutMoms">{{ totalPrice ? ($safeNavigationMigration(totalPrice?.withMoms) | dkCurrency) : '-' }}</span>
              </td>
              <td class="mat-mdc-cell align-right bold relative" *ngIf="pricesWithoutMoms">
                {{ totalPrice ? ($safeNavigationMigration(totalPrice?.withoutMoms) | dkCurrency) : '-' }}
              </td>
              <td class="mat-mdc-cell align-right">
                <button *ngIf="canSeePriceInfo" class="btn-icon fixedprice-active" matTooltip="Vis detaljer for pris" (click)="priceInfo()">
                  <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="table-comment tiny-text flex">
          <i>
            Kunden afregnes efter
            <strong>{{ serviceaftale.kundeOpkraevningModel?.text }}</strong>
          </i>
          <app-info [tooltip]="$safeNavigationMigration(serviceaftale.kundeOpkraevningModel?.description)" [inline]="true"></app-info>
        </div>
        <div class="card__padded-content">
          <div class="data contract__rabat">
            <div class="data__lbl">
              Rabat
              <span *ngIf="rabatEnabled && !serviceaftale?.isEngangsRabat">(årlig)</span>
              <span *ngIf="rabatEnabled && serviceaftale?.isEngangsRabat">(engangs)</span>
            </div>
            <div *ngIf="rabatEnabled" class="data__fullwidth">
              <button
                (click)="openRabatDialog()"
                class="btn-icon blue"
                aria-label="Rediger rabat"
                matTooltip="Rediger rabat"
                [disabled]="!serviceaftale.isActive || !serviceaftale.isRabatEditable"
              >
                <span
                  *ngIf="serviceaftale.rabatKontantInclMoms || serviceaftale.rabatKontantExclMoms"
                  class="medium"
                  [class.strikethrough]="serviceaftale.isCustomerRabatUsed"
                >
                  {{ (isPrivatKunde ? serviceaftale.rabatKontantInclMoms : serviceaftale.rabatKontantExclMoms) | dkCurrency }}
                </span>
                <span *ngIf="serviceaftale.rabatProcent" class="medium" [class.strikethrough]="serviceaftale.isCustomerRabatUsed">
                  {{ serviceaftale.rabatProcent }} %
                </span>
                &nbsp;
                <mat-icon class="blue" svgIcon="edit"></mat-icon>
              </button>
            </div>
            <button
              class="btn-icon"
              type="button"
              [class.red]="rabatEnabled"
              [class.blue]="!rabatEnabled"
              [class.btn-add-small]="!rabatEnabled"
              [disabled]="serviceaftale.serviceaftaleState.state == serviceaftaleStateEnum.Terminated || !serviceaftale.isRabatEditable"
              (click)="rabatChanged()"
              [matTooltip]="rabatEnabled ? 'Fjern rabat' : 'Tilføj rabat'"
            >
              <ng-container *ngIf="!rabatEnabled">
                <mat-icon svgIcon="add-small"></mat-icon>
                Tilføj rabat
              </ng-container>
              <ng-container *ngIf="rabatEnabled">
                <mat-icon svgIcon="delete"></mat-icon>
                Fjern rabat
              </ng-container>
            </button>
          </div>

          <div class="data" *ngIf="canEditFakturaStop">
            <div class="data__fullwidth">
              <mat-slide-toggle
                [disabled]="!canEditFakturaStop"
                color="primary"
                formControlName="fakturastop"
                (change)="changeFakturastop($event)"
              >
                Fakturastop
              </mat-slide-toggle>
            </div>
          </div>
          <div *ngIf="serviceaftale.fastprisaftaler">
            <div class="data">
              <div class="data__lbl">Fast pris aftaler</div>
              <div class="data__fullwidth">
                <table
                  *ngIf="serviceaftale.fastprisaftaler.length > 0"
                  mat-table
                  [dataSource]="dataSource"
                  class="mat-elevation-z0 simple-table"
                >
                  <ng-container matColumnDef="startdate">
                    <th mat-header-cell *matHeaderCellDef>Start</th>
                    <td mat-cell *matCellDef="let fastpris">
                      <div>{{ fastpris.startDate | date : 'dd.MM.yyyy' }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="enddate">
                    <th mat-header-cell *matHeaderCellDef>Udløb</th>
                    <td mat-cell *matCellDef="let fastpris">
                      <div>{{ fastpris.endDate | date : 'dd.MM.yyyy' }}</div>
                    </td>
                  </ng-container>

                  <ng-container *ngIf="isPrivatKunde" matColumnDef="fastpris">
                    <th mat-header-cell class="align-right" *matHeaderCellDef>Fast pris (årlig) inkl. moms</th>
                    <td mat-cell *matCellDef="let fastpris" class="align-right">
                      <div>{{ fastpris.fastPrisInclMoms | dkCurrency }}</div>
                    </td>
                  </ng-container>

                  <ng-container *ngIf="!isPrivatKunde" matColumnDef="fastpris">
                    <th mat-header-cell class="align-right" *matHeaderCellDef>Fast pris (årlig) ekskl. moms</th>
                    <td mat-cell *matCellDef="let fastpris" class="align-right">
                      <div>{{ fastpris.fastPrisExclMoms | dkCurrency }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="rowActions">
                    <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let fastpris; index as i">
                      <div
                        *ngIf="fastpris?.fastprisaftaleState?.id != 1"
                        class="hidden-cell"
                        [class.hidden-cell--inactive]="!serviceaftale.isActive"
                      >
                        <button
                          (click)="editFastprisAftale(fastpris)"
                          class="btn-icon"
                          aria-label="Rediger fast pris aftalen"
                          matTooltip="Rediger fast pris aftalen"
                          [disabled]="fastpris?.fastprisaftaleState?.id == 1 || !serviceaftale.isActive || (!isAdmin && !isSuperUser)"
                        >
                          <mat-icon svgIcon="edit"></mat-icon>
                        </button>
                        <button
                          *ngIf="fastpris?.fastprisaftaleState?.id == 3"
                          (click)="deleteFastprisAftale(fastpris)"
                          class="btn-icon"
                          aria-label="Slet fast pris aftalen"
                          matTooltip="Slet fast pris aftalen"
                          [disabled]="!serviceaftale.isActive || !isAdmin"
                        >
                          <mat-icon svgIcon="delete"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; let i = index; columns: activeColumns"
                    [class.expired]="row.fastprisaftaleState?.id == 1"
                    [class.not-current]="row.fastprisaftaleState?.id == 3"
                    [matTooltip]="$safeNavigationMigration(row.fastprisaftaleState?.text)"
                    matTooltipPosition="above"
                  ></tr>
                </table>
              </div>
              <button
                class="btn-icon blue btn-add-small"
                type="button"
                [disabled]="!serviceaftale.isActive || (!isSuperUser && !this.isAdmin)"
                (click)="addFastpris()"
              >
                <mat-icon svgIcon="add-small"></mat-icon>
                Tilføj fast pris aftale
              </button>
            </div>
          </div>
        </div>
        <table class="mat-mdc-table margin-bottom">
          <thead>
            <tr class="mat-mdc-header-row">
              <th class="mat-mdc-header-cell">
                Rabat på serviceordre
                <app-info [tooltip]="'Kontorabat i G4.'" [inline]="true"></app-info>
              </th>
              <th class="mat-mdc-header-cell align-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell">På timer</td>
              <td class="mat-mdc-cell align-right">
                <span *ngIf="serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.timerPct == null" class="medium">
                  Ingen rabat på timer.
                </span>
                <span *ngIf="serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.timerPct != null" class="medium">
                  {{ serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.timerPct }}% på timer.
                </span>
              </td>
            </tr>
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell">På materialer</td>
              <td class="mat-mdc-cell align-right">
                <span *ngIf="serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.materialerPct == null" class="medium">
                  Ingen rabat på materialer.
                </span>
                <span *ngIf="serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.materialerPct != null" class="medium">
                  {{ serviceaftale.kunde?.kundeExtendedInformation?.kontoRabat?.materialerPct }}% på materialer.
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
  <div class="flex-wrap__col flex-wrap__col--60 second-col">
    <app-anlaeg
      *ngIf="serviceaftale.anlaeg"
      [anlaeg]="serviceaftale.anlaeg"
      [serviceAftaleAdresse]="$safeNavigationMigration(serviceaftale.kunde?.anlaegsadresse?.adressLine)"
      [product]="$safeNavigationMigration(serviceaftale.serviceAbonnement?.product)"
      [tilvalg]="serviceaftale.tilvalg"
      (anlaegChange)="onAnlaegChanged($event)"
      [serviceaftale]="serviceaftale"
    ></app-anlaeg>
  </div>
</div>
